import React, { useState, useEffect } from "react";

import "../../CSS/CookieConsentBanner.css"


const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleConsent = (type) => {
    localStorage.setItem("cookieConsent", type);
    setShowBanner(false);
    // You can handle logic based on the type here
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-text">
        We use cookies to personalize your experience. Manage your preferences below.
      </div>
      <div className="cookie-buttons">
        <button className="cookie-btn" onClick={() => handleConsent("none")}>
          Relect All
        </button>
        <button className="cookie-btn" onClick={() => handleConsent("selected")}>
          Allow Selected
        </button>
        <button className="cookie-btn" onClick={() => handleConsent("all")}>
          Accept All
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
